import BaseComponent from "../../../baseComponent.js";
import AppConfig from "../../../../config/config.js"
import ColorUtil from "../../../../core/utils/colorUtil.js";
import styles from "./styles.scss";

export default class Color extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleClick(event) {
    let index = $(this.refs.container.children).index(event.currentTarget);
    this.props.onLegendChange(this.props.field || "legendColor", AppConfig.DEFAULT_LEGEND_COLORS[index]);
  }

  render() {
    let colorSelectors = AppConfig.DEFAULT_LEGEND_COLORS.map((color, index) => {
      let style = {
        backgroundColor: color
      };
      let borderStyle = {
        borderColor: ColorUtil.shadeColor(color, -20)
      };
      let className = color == this.props.color ?
        styles.selectedColor : styles.colorOption;
      return <div key={index}
                  className={className}
                  style={style} onClick={this.handleClick}>
        <div style={borderStyle}></div>
      </div>
    });

    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          {
            this.props.label === false ? null :
              <div className={styles.configLabel}>{this.props.label || "Color"}</div>
          }
          <div className={styles.colors} ref="container">
            {colorSelectors}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/color.jsx